const actions = {
  CREATE_MEMBER_TICKET: 'CREATE_MEMBER_TICKET',
  CREATE_MEMBER_TICKET_ENDED: 'CREATE_MEMBER_TICKET_ENDED',
  CREATE_ISSUED_MEMBER_TICKET: 'CREATE_ISSUED_MEMBER_TICKET',
  CREATE_ISSUED_MEMBER_TICKET_ENDED: 'CREATE_ISSUED_MEMBER_TICKET_ENDED',
  ALLOCATE_MEMBER_TICKETS: 'ALLOCATE_MEMBER_TICKETS',
  ALLOCATE_MEMBER_TICKETS_ENDED: 'ALLOCATE_MEMBER_TICKETS_ENDED',
  REDEEM_ISSUED_MEMBER_TICKET: 'REDEEM_ISSUED_MEMBER_TICKET',
  REDEEM_ISSUED_MEMBER_TICKET_ENDED: 'REDEEM_ISSUED_MEMBER_TICKET_ENDED',
  UNDO_ISSUED_MEMBER_TICKET_REDEMPTION: 'UNDO_ISSUED_MEMBER_TICKET_REDEMPTION',
  UNDO_ISSUED_MEMBER_TICKET_REDEMPTION_ENDED: 'UNDO_ISSUED_MEMBER_TICKET_REDEMPTION_ENDED',
  REVOKE_ISSUED_MEMBER_TICKET: 'REVOKE_ISSUED_MEMBER_TICKET',
  REVOKE_ISSUED_MEMBER_TICKET_ENDED: 'REVOKE_ISSUED_MEMBER_TICKET_ENDED',
  SEARCH_MEMBER_TICKETS: 'SEARCH_MEMBER_TICKETS',
  SEARCH_MEMBER_TICKETS_ENDED: 'SEARCH_MEMBER_TICKETS_ENDED',
  SEARCH_ISSUED_MEMBER_TICKETS: 'SEARCH_ISSUED_MEMBER_TICKETS',
  SEARCH_ISSUED_MEMBER_TICKETS_ENDED: 'SEARCH_ISSUED_MEMBER_TICKETS_ENDED',
  SEARCH_MEMBER_TICKET_TRANSACTION_RECORDS: 'SEARCH_MEMBER_TICKET_TRANSACTION_RECORDS',
  SEARCH_MEMBER_TICKET_TRANSACTION_RECORDS_ENDED: 'SEARCH_MEMBER_TICKET_TRANSACTION_RECORDS_ENDED',
  SEARCH_MEMBER_TICKET_TRANSFER_RECORDS: 'SEARCH_MEMBER_TICKET_TRANSFER_RECORDS',
  SEARCH_MEMBER_TICKET_TRANSFER_RECORDS_ENDED: 'SEARCH_MEMBER_TICKET_TRANSFER_RECORDS_ENDED',
  GET_ISSUED_MEMBER_TICKET_BATCHES: 'GET_ISSUED_MEMBER_TICKET_BATCHES',
  GET_ISSUED_MEMBER_TICKET_BATCHES_ENDED: 'GET_ISSUED_MEMBER_TICKET_BATCHES_ENDED',
  FIND_MEMBER_TICKET: 'FIND_MEMBER_TICKET',
  FIND_MEMBER_TICKET_ENDED: 'FIND_MEMBER_TICKET_ENDED',
  UPDATE_MEMBER_TICKET: 'UPDATE_MEMBER_TICKET',
  UPDATE_MEMBER_TICKET_ENDED: 'UPDATE_MEMBER_TICKET_ENDED',
  UPDATE_ISSUED_MEMBER_TICKET_BATCH: 'UPDATE_ISSUED_MEMBER_TICKET_BATCH',
  UPDATE_ISSUED_MEMBER_TICKET_BATCH_ENDED: 'UPDATE_ISSUED_MEMBER_TICKET_BATCH_ENDED',
  UPDATE_ISSUED_MEMBER_TICKET: 'UPDATE_ISSUED_MEMBER_TICKET',
  UPDATE_ISSUED_MEMBER_TICKET_ENDED: 'UPDATE_ISSUED_MEMBER_TICKET_ENDED',
  DELETE_MEMBER_TICKETS: 'DELETE_MEMBER_TICKETS',
  DELETE_MEMBER_TICKETS_ENDED: 'DELETE_MEMBER_TICKETS_ENDED',
  GET_MEMBER_TICKET_STATISTICS: 'GET_MEMBER_TICKET_STATISTICS',
  GET_MEMBER_TICKET_STATISTICS_ENDED: 'GET_MEMBER_TICKET_STATISTICS_ENDED',
  REVOKE_VOUCHER_TICKET: 'REVOKE_VOUCHER_TICKET',
  REVOKE_VOUCHER_TICKET_ENDED: 'REVOKE_VOUCHER_TICKET_ENDED',
  SEARCH_VOUCHER_WITH_MEMBER_ID: 'SEARCH_VOUCHER_WITH_MEMBER_ID',
  SEARCH_VOUCHER_WITH_MEMBER_ID_ENDED: 'SEARCH_VOUCHER_WITH_MEMBER_ID_ENDED',
  SEARCH_REDEEM_RECORD_AND_TICKETS: 'SEARCH_REDEEM_RECORD_AND_TICKETS',
  SEARCH_REDEEM_RECORD_AND_TICKETS_ENDED: 'SEARCH_REDEEM_RECORD_AND_TICKETS_ENDED',
  SEARCH_REDEEM_RECORD_DETAILS_AND_TICKETS: 'SEARCH_REDEEM_RECORD_DETAILS_AND_TICKETS',
  SEARCH_REDEEM_RECORD_DETAILS_AND_TICKETS_ENDED: 'SEARCH_REDEEM_RECORD_DETAILS_AND_TICKETS_ENDED',
};

export default actions;
